import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RegistrationAdminService } from '../../shared/services/registration-admin.service';
import { Languages, Service, ServiceStatus, FormMode } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AgentCurrencyDto, AgentCurrencyListDto } from '../../shared/models/agent-currency.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';

@Component({
  selector: 'app-enter-each-currency',
  templateUrl: './enter-each-currency.component.html',
  styleUrls: ['./enter-each-currency.component.css']
})
export class EnterEachCurrencyComponent implements OnInit {

  user: User = new User();
  registerTreasuryNumberForm: FormGroup;
  displayedLang: string;
  baseRequestId: string = '';
  submitted = false;
  loading = false; requestStatus: number;

  getAgentCurrency: AgentCurrencyDto[] = [];
  error: any = { isError: false, errorMessage: '' };
  agentCurrency: AgentCurrencyDto[] = [];
  isReadOnly = true;
  agentCurrencyList: AgentCurrencyListDto = new AgentCurrencyListDto();
  baseRequestDTO: BaseRequest;
  showRequest = false;
  public FormMode: any = FormMode;
  public formMode = FormMode.Add;

  numberRegex: string = '^[0-9]*$';
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean=false;
  DuplicateTreasuryNumber: boolean=false;
  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices, private alertService: AlertService,
    private route: ActivatedRoute, private adminSrv: RegistrationAdminService, private router: Router,
    private translate: TranslateService,
    private authenticationService: AuthenticationService,
    private baseRequestService: BaseRequestService, ) {
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    //this.baseRequestId = this.route.snapshot.params.Id;

    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      // this.getBaseRequest();
    }
    else {
      window.history.back();
    }
    this.user = this.authenticationService.currentUserValue;

  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.registerTreasuryNumberForm = this.formBuilder.group({
      IsPaymentConfirmed: ['', [Validators.requiredTrue]],
      AgentCurrencyDto: this.formBuilder.array([]),
    });
    this.adminSrv.getAgentCurrency(this.baseRequestId)
      .subscribe((data: ResponseObject) => {
        if (data.Success) {
          this.agentCurrency = data.Data as AgentCurrencyDto[];

          this.baseRequestService.getByRequestorId(this.baseRequestId, Service.AgentRegisteration).subscribe(
            d => {
              this.baseRequestDTO = d.Data;
              this.requestStatus = this.baseRequestDTO.StatusId;
              this.bindAttachments(this.agentCurrency);

            }
          )
        }
        // this.registerTreasuryNumberForm.setControl('AgentCurrencyDto', this.bindAttachments(this.agentCurrency));
      }
      );

  }

  get f() {
    return this.registerTreasuryNumberForm.controls;
  }
  get Currency() {
    return this.registerTreasuryNumberForm.get('AgentCurrencyDto') as FormArray;
  }

  bindAttachments(currency): any {
    let control = <FormArray>this.registerTreasuryNumberForm.controls['AgentCurrencyDto'];
    if (history.state.data && history.state.data.isCompleted) {
      this.registerTreasuryNumberForm.patchValue({
        IsPaymentConfirmed: true,
      });
      this.formMode = FormMode.Readonly;
      this.registerTreasuryNumberForm.disable();
    }
    currency.forEach((key) => {
 if (history.state.data && history.state.data.isCompleted) {
        if (this.globalSrv.getLanguage() == Languages.Arabic) {
          control.push(new FormGroup({
            CurrencyName: new FormControl({ value: key.Currency.NameAR, disabled: true }),
            TreasuryNumber: new FormControl({ value: key.TreasuryNumber, disabled: true }),
            CurrencyId: new FormControl({ value: key.CurrencyId }),
            Id: new FormControl({ value: key.Id }),
            AgentId: new FormControl({ value: key.AgentId })
          }));
        }
        if (this.globalSrv.getLanguage() == Languages.English) {
          control.push(new FormGroup({
            CurrencyName: new FormControl({ value: key.Currency.NameEN, disabled: true }),
            TreasuryNumber: new FormControl({ value: key.TreasuryNumber, disabled: true }),
            CurrencyId: new FormControl({ value: key.CurrencyId }),
            Id: new FormControl({ value: key.Id }),
            AgentId: new FormControl({ value: key.AgentId })
          }));
        }
        this.formMode = FormMode.Readonly;
        this.registerTreasuryNumberForm.disable();
      }
      else {

        if (this.globalSrv.getLanguage() == Languages.Arabic) {
          control.push(new FormGroup({
            CurrencyName: new FormControl({ value: key.Currency.NameAR, disabled: true }),
            TreasuryNumber: new FormControl('', [Validators.required, Validators.pattern(this.numberRegex)]),
            CurrencyId: new FormControl({ value: key.CurrencyId }),
            Id: new FormControl({ value: key.Id }),
            AgentId: new FormControl({ value: key.AgentId })
          }));
        }
        if (this.globalSrv.getLanguage() == Languages.English) {
          control.push(new FormGroup({
            CurrencyName: new FormControl({ value: key.Currency.NameEN, disabled: true }),
            TreasuryNumber: new FormControl('', Validators.required),
            CurrencyId: new FormControl({ value: key.CurrencyId }),
            Id: new FormControl({ value: key.Id }),
            AgentId: new FormControl({ value: key.AgentId })
          }));
        }
      }
    });
    return control;
  }

  transformCurrency(Currencies: any[]): AgentCurrencyListDto {
    //this.agentCurrencyList.AgentCurrencyDto=[];
    if (Currencies.length > 0) {
      Currencies.forEach(element => {
        element.CurrencyId = element.CurrencyId.value;
        element.AgentId = element.AgentId.value;
        element.Id = element.Id.value;
        element.TreasuryNumber = element.TreasuryNumber;
        this.agentCurrencyList.AgentCurrencyDto.push(element);
      });
    }
    return this.agentCurrencyList;
  }
  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.registerTreasuryNumberForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.loading = true;

    this.globalSrv.isLoaderEnabled = true;

    this.agentCurrencyList = this.transformCurrency(this.registerTreasuryNumberForm.value.AgentCurrencyDto);
    // let currencyList = this.agentCurrencyList;
    // var valueArr = currencyList.AgentCurrencyDto.map(function (item) { return item.TreasuryNumber });
    // var isDuplicate = valueArr.some(function (item, idx) {
    //   return valueArr.indexOf(item, idx + 1) !== -1;
    // });
    // if (isDuplicate) {
    //   this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.DuplicateTreasuryNumber'));
    //   window.scrollTo(0, 0);
    //   this.globalSrv.isLoaderEnabled = false;
    //   return;
    // }

    this.agentCurrencyList.AdminEmail = this.user.UserName;
    this.agentCurrencyList.RequestId = this.baseRequestId;
    this.adminSrv.UpdateTreasuryNumbers(this.agentCurrencyList)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            //this.alertService.success(this.translate.instant('FRONT_USER.SUCCESS_MESSAGES.ADD_SUCCESSFULLY'));

            this.globalSrv.isLoaderEnabled = false;
            this.registerTreasuryNumberForm.reset();
            this.showRequest = true;
            this.isErrorMessage = false;
          } else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.globalSrv.isLoaderEnabled = false;
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
          }
          else if (data.ErrorMessages.find(e => e == "DuplicateTreasuryNumber") != null) {
            this.globalSrv.isLoaderEnabled = false;
            this.DuplicateTreasuryNumber = true;
            this.showRequest = true;
          } else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            // this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]));
          }

        });
  }


  onChangeTreasury(event, control) {

    let treasuryNumber = event.target.value;
    if (treasuryNumber) {
      this.adminSrv.CheckTreasuryNumber(treasuryNumber).subscribe((data: ResponseObject) => {
        if (!data.Success) {
          // this.error = { isError: true, errorMessage: this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]) };
          control.setErrors({ duplicatedNumber: true });
        }
        else {
          //this.error = { isError: false, errorMessage: '' };
          control.setErrors(null);
          control.setValidators([Validators.required, Validators.pattern(this.numberRegex)]);
          control.updateValueAndValidity();
        }

      });
    }
  }
}
